import * as api from '../../lib/api';

export function fetchAll() {

  return async (dispatch) => {
    let faqs = await api.invoke({path: '/faqs'});
    dispatch({
      type: 'FAQS__UPDATE_LIST',
      faqs,
    });
    return faqs;
  };
}

export function remove(id) {
  return async (dispatch) => {
    return await api.invoke({path: `/admin/faqs/${id}`, method: 'DELETE'});
  };
}

export function createOrUpdate(faq) {
  return async (dispatch) => {
    if (faq.faqId) {
      return await api.invoke({
        path: `/admin/faqs/${faq.faqId}`,
        method: 'PUT',
        body: faq,
      });
    } else {
      return await api.invoke({
        path: `/admin/faqs`,
        method: 'POST',
        body: faq,
      });
    }
  };
}


// WEBPACK FOOTER //
// ./src/store/actions/faqs.js